import React, { useState } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import * as firebase from "firebase/app";

import routes from "../../routes";
import Layout from "./Layout";
import useErrorProvider from "../../hooks/useErrorProvider";
import useRouter from "../../hooks/useRouter";
import BusyButton from "../../components/BusyButton";

export default function Recover() {
  const { reportError } = useErrorProvider();
  const { routeTo } = useRouter();

  const [isBusy, setBusy] = useState(false);
  const [email, setEmail] = useState("");

  const onChangeEmail = e => {
    setEmail(e.target.value);
  };

  const onSubmit = e => {
    e.preventDefault();
    setBusy(true);
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => routeTo(routes.account.reset))
      .catch(reportError)
      .finally(() => setBusy(false));
  };
  return (
    <Layout.Container>
      <h3>Forgotten Password?</h3>
      <p>
        No problem! Please enter your email address and we'll send you a
        password reset email.
      </p>
      <Form onSubmit={onSubmit}>
        <FormGroup>
          <Label for="email">Your Email</Label>
          <Input
            name="email"
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={onChangeEmail}
          />
        </FormGroup>
        <Layout.Footer>
          <div>
            Already have an acount?&nbsp;
            <a href={routes.account.signin}>Sign In</a>
          </div>
          <BusyButton type="submit" color="primary" isBusy={isBusy}>
            Reset Password
          </BusyButton>
        </Layout.Footer>
      </Form>
    </Layout.Container>
  );
}
